import React from 'react';
import {connectToWebChat} from 'botframework-webchat';
import ActivityWithSuggestedActions from './ActivityWithSuggestedActions';

const ConnectedActivityWithSuggestedActions = connectToWebChat(
  ({ postActivity }) => ({ postActivity })
)(props => <ActivityWithSuggestedActions { ...props } />)

export default ConnectedActivityWithSuggestedActions;